<template>
  <div class="body">
    <div class="top">
      <div class="topImg">
        <img src="@/assets/img/43222.png" alt="">
      </div>
      <div class="tis">新品推荐 . 官方正品 . 优惠套餐</div>
      <div class="el-top-flex">
        <div class="left-top">
          <div class="left-100">100G</div>
          <div class="left-8">8<span>元/月</span></div>
        </div>
        <div class="right-top">
          <div class="right-yx">月享</div>
          <div class="right-skie">高速全国通用流量</div>
        </div>
      </div>
    </div>
    <div class="dhq">
      <div class="quans">
        <div class="left-top">20<span>元 X </span>24<span>张</span></div>
        <!-- <div class="left-top">100<span>元 X </span>1<span>张(年包券)</span></div> -->
        <div class="left-bottom">首充100获得</div>
      </div>
      <div class="right-2">兑换券</div>
    </div>
    <div class="tcjs">
      <div class="tcjs-8">8元套餐介绍</div>
      <div class="tcjs-title">原套餐28包100G</div>
      <div class="tcjs-cnet"><span>参与冲100元得480元活动，</span>，480元活动余额直接到账，订购套餐，即可畅享网络。</div>
      <!-- <div class="btn" @click="isDialogShow=true">立即领取 </div> -->
       <div class="btn" @click="sureToRecharge()">立即领取 </div>
    </div>
    <div class="fotter">
      <div class="f-title">没有定向流量，100G全部都是通用流量</div>
      <div class="f-cte">上述套餐全部都为长期套餐</div>
    </div>

    <!--显示活动弹窗-->
    <div v-if="isDialogShow" class="v-dialog">
      <div class="v-dialog-bg" />
      <div class="v-dialog-content">
        <div class="input">{{ input }}</div>
        <div class="sumbit_btn" @click="sureToRecharge()" />
        <div class="v-dialog-close">
          <img src="@/assets/dzp/dialog_close.png" alt="" @click="isDialogShow=false">
        </div>
      </div>
    </div>
    <!-- 修改密码框   -->
    <div v-show="showPasswordPanel" class="van-overlay" style="z-index: 1999;" />
    <div
      v-show="showPasswordPanel"
      class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp"
      style="z-index: 2000; min-height: 25%; min-width: 80%;"
      :style="{top:passwordPanelTop+'%'}"
    >

      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />

      <!-- 密码输入框 -->
      <p>设置开户支付密码：</p>
      <van-password-input
        :value="password"
        :focused="passwordKeyboard"
        @focus="passwordOnfocus()"
      />

      <!-- 再次确认密码输入框 -->
      <p>再次确认开户密码：</p>
      <van-password-input
        :value="confirmPassword"
        :focused="confirmPasswordKeyboard"
        @focus="confirmPasswordOnfocus()"
      />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToRecharge()">确 定
        </van-button>
      </div>

    </div>

    <!-- 数字键盘 -->
    <van-number-keyboard
      :z-index="2015"
      :show="passwordKeyboard"

      @input="passwordOnInput"
      @delete="passwordOnDelete"
      @blur="passwordKeyboard = false"
    />

    <van-number-keyboard
      :z-index="2015"
      :show="confirmPasswordKeyboard"

      @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete"
      @blur="confirmPasswordKeyboard = false"
    />
    <!-- 数字键盘 end -->
    <!-- 修改密码框 end  -->
  </div>
</template>
<script>
import { Dialog } from 'vant'
import { wxRequest } from '@/api/user.js'
export default {
  data() {
    return {
      newHome: this.$store.state.newHome,
      newHomes: localStorage.getItem('newHome'),
      input: this.$store.state.recordLoginText,
      isDialogShow: false,
      // 设置密码
      password: '',
      confirmPassword: '',
      alreadySetUp: false,
      showPasswordPanel: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,

      // 当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,

      // 自定义金额
      popup: false,

      // 自定义键盘
      showKeyboard: false,
      definedPrice: '',

      type: '',
      indexActive: ''
    }
  },
  methods: {
    /** *   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true
      this.confirmPasswordKeyboard = false
      this.passwordPanelTop = 30
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1)
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6)
    },

    confirmPasswordOnfocus() {
      this.passwordKeyboard = false
      this.confirmPasswordKeyboard = true
      this.passwordPanelTop = 30
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1)
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6)
    },

    cancelChangePassword() {
      this.password = ''
      this.confirmPassword = ''
      this.passwordPanelTop = 50
      this.showPasswordPanel = false
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: '请设置六位支付密码' })
        return false
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: '两次输入的新密码不一致' })
        return false
      }
      return true
    },

    /** *   修改密码  end   ***/
    sumbit() {
      this.showPasswordPanel = true
    },
    onBridgeReady(param) {
      const _this = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest', param,
        function(res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            if (this.newHome == 1 || this.newHomes == 1) {
              _this.$router.push({
                path: '/user/home',
                query: {
                  iccid: _this.$store.state.iccid
                }
              }).catch(() => {

              })
            } else {
              _this.$router.push({
                path: '/user/home',
                query: {
                  iccid: _this.$store.state.iccid
                }
              }).catch(() => {

              })
            }
          }
        }
      )
    },
    sureToRecharge() {
      var params = {
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem('iccid'),
        amount: 100 * 100, // 固定值
        giftBalance: 0, // 固定值
        yucun: 1, // 固定值
        payType: 20 // 固定微信支付

      }
      wxRequest('order/user/create/priceOrder', params, 'post').then(res => {
        if (res.data.code == 200) {
          if (params.payType == 50) { // 乐刷
            window.location.href = res.data.data.jspay_url
          } else if (params.payType == 20) { // 微信第三方
            var param = res.data.data.param
            if (typeof WeixinJSBridge === 'undefined') {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false)
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
              }
            } else {
              this.onBridgeReady(param)
            }
          } else if (params == 60) { // 汇付天下
            const datas = JSON.parse(res.data.data)
            if (datas.status === 'succeeded') {
              const payment = datas
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: '提示', message: res.result_message })
              })
            }
          }
        } else {
          Dialog.alert({ message: res.data.message })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.body{
    width:100%;
    height:100vh;
    position: relative;
    padding-bottom:50px;
    .top{
        height:312px;
        background: url('../../assets/img/bg.png') no-repeat center top;
        background-size:100%;
        .topImg{
            width: 151px;
            height: 40px;
            margin: auto;
            padding-top:60px;
            img{
                height:100%;
                width:100%;
            }
        }
        .tis{
            margin-top:14px;
            color:#fff;
            font-size:16px;
            text-align: center;
        }
        .el-top-flex{
            display: flex;
            margin-top: 34px;
            margin-left:34px;
            .left-top{
                margin-right: 10px;
                .left-100{
                    font-size:48px;
                    color:#F74D12;
                    font-family: HarmonyOS_Sans_SC_Black;
                    line-height: 68px;
                    font-weight:700;
                }
                .left-8{
                    font-size:30px;
                    color:#E2A542;
                    span{
                        font-size:17px;
                    }
                }
            }
            .right-top{
                margin-top:15px;
                .right-yx{
                    width: 38px;
                    height: 22px;
                    background: #E2A542;
                    border-radius: 4px;
                    line-height:22px;
                    text-align: center;
                    color: #FFFEFA;
                }
                .right-skie{
                    color: #E2A542;
                    line-height: 19px;
                    font-size: 14px;
                }
            }
        }
    }
    .dhq{
        display: flex;
        background: url('../../assets/img/1223231.png') no-repeat center;
        width:90%;
        justify-items: center;
        background-size:100%;
        align-items: center;
        margin:auto;
        height:82px;
        .quans{
            width: 75%;
            .left-top{
                color: #F74D12;
                font-size:22px;
                padding-left:26px;
                span{
                    font-size:14px;
                    display: inline-block;
                    margin:0 5px;
                }
            }
            .left-bottom{
                padding-left:26px;
                font-size:14px;
                color: #797979;
                margin-top:4px;

            }
        }
        .right-2{
            color:#fff;
            font-size:18px;
        }
    }
    .tcjs{
        position: relative;
        width:90%;
        margin: auto;
        margin-top:14px;
        border-radius: 6px;
        border: 1px solid #F9EBCE;
        .tcjs-8{
            position: absolute;
            top:0;
            width: 91px;
            height: 26px;
            left:0;
            border-radius: 6px 0px 6px 0px;
            background: linear-gradient(180deg, #FFF8EB 0%, #F8E8C7 100%);
            font-weight: 500;
            color: #C4A768;
            line-height: 26px;
            font-size: 14px;
            text-align: center;
        }
        .tcjs-title{
            font-family: PingFangSC-Semibold, PingFang SC;
            margin-top:36px;
            font-size: 22px;
            color: #171717;
            text-align: center;
        }
        .tcjs-cnet{
            padding:15px;
            color: #797979;
            font-size:15px;
            text-align: center;
            line-height: 24px;
            span{
                color:#FF6B42;
            }
        }
        .btn{
            margin: auto;
            height: 46px;
            line-height:46px;
            font-size:22px;
            color:#fff;
            width:90%;
            background: #F86C2E;
            text-align: center;
            margin-bottom:16px;
            border-radius: 23px;
        }
    }
    .fotter{
        width:90%;
        margin:10px auto;
        border-radius: 6px;
        background: linear-gradient(180deg, #FFF8EB 0%, #F8E8C7 100%);
        text-align: center;
        .f-title{
            padding:10px 20px 16px;
            font-size:16px;
            color: #171717;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight:600;
        }
        .f-cte{
            height: 48px;
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #797979;
            padding:0 15px 16px;
            line-height: 24px;
        }
    }

    .v-dialog{
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        bottom: 0;
        left:0;
        right:0;
        margin:auto;
        .v-dialog-bg{
            position: fixed;
            background: rgba(0,0,0, .7);
            top:0;
            bottom: 0;
            left:0;
            right:0;
            margin:auto;
            width:100%;
            height:100%;
        }
        .v-dialog-close{
            width:22px;
            height:22px;
            // margin:0 auto;
            // margin-top:20px;
            position: fixed;
            top:0;
            bottom:-300px;
            left:0;
            right:0;
            margin:auto;
            img{
                height:100%;
                cursor: pointer;
            }
        }
        .v-dialog-content{
            position: fixed;
            top:0;
            bottom: 0;
            left:0;
            right:0;
            margin:auto;
            width: 275px;
            height: 210px;
            background: url('../../assets/dzp/100.jpg') no-repeat center;
            background-size:100% 100%;
            .input{
                background: rgb(255, 255, 255);
                width: 200px;
                height: 40px;
                margin: auto;
                margin-bottom: 10px;
                border-radius: 12px;
                text-align: center;
                line-height: 40px;
                font-size: 25px;
                color: rgb(177, 54, 0);
                position: absolute;
                bottom:54px;
                display: flex;
                left:0;
                right:0;
                justify-content: center;
                align-items: center;
            }
            .sumbit_btn{
                width: 175px;
                height: 46px;
                position: absolute;
                bottom:8px;
                display: flex;
                left:0;
                margin: auto;
                right:0;
                background: url('../../assets/dzp/a2.png') no-repeat center;
                background-size:100% 100%;
            }
        }
    }
}
.changePasswordPanel-cardSetUp{
    padding: 10px;
    .icon-cross{
    position: absolute;
    right: 10px;
    font-size: 16px;
    }

    p{
    margin: 10px 16px 0 16px;
    line-height: 30px;
    }

    .confirmChangePassword{
    display:flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn{
        width: 80px;
        margin: 0 15px;
    }
    }

}
</style>
